import * as XLSX from "xlsx";

/**
 * exportRowsAsCsv
 *
 * No CSV-export utility exists anywhere in this codebase yet (xlsx is only
 * ever used to *read* uploaded files elsewhere — see OrganizationHierarchy.jsx
 * / SbBulkJdUpload.jsx). This is the first write-side use, built on the same
 * already-installed `xlsx` dependency plus the Blob + <a download> pattern
 * already established in CompensationManagement.jsx.
 *
 * @param {Array<Object>} rows - plain objects, one per CSV row
 * @param {string} filename - without extension
 */
export const exportRowsAsCsv = (rows = [], filename = "export") => {
  if (!rows.length) return;
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const csv = XLSX.utils.sheet_to_csv(worksheet);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
